import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const CurtainShirt = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.CurtainShirt.itemName}
      name={AW23.tops.CurtainShirt.itemName}
      price={AW23.tops.CurtainShirt.itemPrice}
      fabric={AW23.tops.CurtainShirt.itemFabric}
      src={AW23.tops.CurtainShirt.sizeChart}
      divId={AW23.tops.CurtainShirt.shopifyDivId}
      mainId={AW23.tops.CurtainShirt.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.CurtainShirt.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.CurtainShirt.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default CurtainShirt;
